import { PROFILE_ACTION_TYPES } from 'store/actions/profile.actions';

const initialState = {
  representativeDetails: {},
  representativeEditInitial: {},
  sponsorEditInitial: {},
  processing: {
    isFormProcessed: false,
    representativeProfile: false,
  },
};

export default function (state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case PROFILE_ACTION_TYPES.PROFILE_SET_DATA_BY_KEY:
      return { ...state, [payload.stateKeyForDataSaving]: { ...payload.data } };

    case PROFILE_ACTION_TYPES.PROFILE_CHANGE_PROCESSING:
      return {
        ...state,
        processing: {
          ...state.processing,
          [payload.processingDestination]: payload.newState,
        },
      };

    case PROFILE_ACTION_TYPES.PROFILE_CLEAR_STATE:
      if (payload.shouldDeleteProperty) {
        const { [payload.clearedKey]: clearedKey, ...stateTail } = state;
        return { ...stateTail };
      } else {
        return { ...state, [payload.clearedKey]: {} };
      }

    default:
      return state;
  }
}
